import { ChangeDetectorRef, Component, Inject, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { ReportsService } from 'app/core/services/reports/reports.service';
import { ReportService } from '../../services/reports.service';
import { ZuperDialogService } from '@zuper/components/zuper-dialog';
import { ReportSuccessDialogComponent } from '../report-success-dialog/report-success-dialog.component';
import { NewFolderComponent } from '../new-folder/new-folder.component';
import { FolderService } from '../../services/folder.service';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-move-folder',
  templateUrl: './move-folder.component.html',
  styleUrls: ['./move-folder.component.scss']
})
export class MoveFolderComponent implements OnInit, OnDestroy {
  selectedFolder: any;
  myReports: any;
  folders: any;
  type: any;
  folderSubscription: Subscription;
  currentFolder: any;
  constructor(
    public matDialogRef: MatDialogRef<MoveFolderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private reportsService: ReportService,
    private dataCollectorService: DataCollectorService,
    private zuperDialogService: ZuperDialogService,
    private folderService: FolderService,
    private localStorageService: LocalStorageService,
    private reportService: ReportService) { }

  ngOnInit(): void {
    this.folderSubscription = this.reportService.storedFolders$.subscribe((res) => {
      this.folders = res?.data;
    });
    if (this.data?.data?.selectedFolder) {
      this.selectedFolder = this.data?.data?.selectedFolder;
      this.currentFolder = this.data?.data?.selectedFolder;
    }
    else {
      this.selectedFolder = {
        key: 'my_report'
      };
    }
    this.isMoveDisabled();
  }

  isMoveDisabled(): boolean {
    return this.currentFolder?.folder_uid === this.selectedFolder?.folder_uid;
  }

  closeModal(): void {
    this.matDialogRef.close();
  }

  highlightFolder(folder: any): void {
    this.selectedFolder = folder;
    this.isMoveDisabled();
  }
  openMoveSuccessDialog(): void {
    const createReportDialog = this.zuperDialogService.openCustom(ReportSuccessDialogComponent, {
      disableClose: true,
      dismissible: false,
      extraClass: 'report-success-dialog',
      hasBackdrop: true,
      data: {
        sourceFolder: this.data?.data?.report?.report_name,
        destinationFolder: this.selectedFolder
      }
    });
    createReportDialog.afterClosed().subscribe((result) => {
    });
  }
  openNewFolder(): any {
    const openNewFolderDialog = this.zuperDialogService.openCustom(NewFolderComponent, {
      data: {
        action: 'new'
      },
      extraClass: 'new-folder-dialog',
    });
    openNewFolderDialog.afterClosed().subscribe((result: any) => {
      if (result?.value) {
        this.selectedFolder = result?.response?.data;
      }
    });
  };
  onMoveFolder(): void {
    if (this.data?.data?.selectedFolder?.folder_uid) {
      this.reportsService.moveFolder(this.data?.data?.selectedFolder?.folder_uid, this.selectedFolder?.folder_uid, this.data?.data?.report?.report_uid).subscribe((res) => {
        this.openMoveSuccessDialog();
        this.matDialogRef.close({ status: true });
      });
    }
    else {
      this.reportService.addReportsToFolder(this.selectedFolder?.folder_uid, this.data?.data?.report?.report_uid).subscribe((res) => {
        this.openMoveSuccessDialog();
        this.matDialogRef.close({ status: true });
      });
    }
  }
  ngOnDestroy(): void {
    this.folderSubscription?.unsubscribe();
  }


}
